// extracted by mini-css-extract-plugin
export default {"container":"dashboard-layout_container__ToHoN","truncate-table":"dashboard-layout_truncate-table__Nq6ry","table-text-faded":"dashboard-layout_table-text-faded__E6GTT","layout":"dashboard-layout_layout__PzWp+","tableColumn":"dashboard-layout_tableColumn__tvnAL","sidebar":"dashboard-layout_sidebar__SxLwq"};
    if(module.hot) {
      // 1793877077218
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  